import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output
} from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { BreakpointObserver } from '@angular/cdk/layout';
import { saveAs } from 'file-saver';
import { Subject, takeUntil } from 'rxjs';

import { DocumentService } from '@shared/services/document.service';
import { FileData } from '@shared/models/catalog.service';
import { ServerLinks } from '@shared/services/server-links';
import { ServerLinkName } from '@shared/models/server-links-model';
import { CustomIcons } from '@shared/models/custom-icons';

@Component({
  selector: 'app-download-link',
  templateUrl: './download-link.component.html',
  styleUrls: ['./download-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DownloadLinkComponent {
  fileData = input.required<FileData | undefined>();
  isMultiple = input<boolean>(false);
  showIcon = input<boolean>(false);
  onMultipleClick = output<MouseEvent>();
  document = inject(DOCUMENT);
  documentService = inject(DocumentService);
  serverLinks = inject(ServerLinks);
  breakpointObserver = inject(BreakpointObserver);
  breakPointObserve$ = this.breakpointObserver.observe(['(max-width: 800px)']);
  destroy$ = new Subject<void>();
  icons = CustomIcons;

  get fileName(): string {
    return `${ this.fileData()?.fileName || '' }${ this.fileData()?.extention || '' }`;
  }

  get isImage() {
    return this.fileData()?.type.includes('image') && !this.fileData()?.type.includes('svg');
  }

  onClick(event: Event) {
    event.stopPropagation();

    const id = this.fileData()?.id;
    if (!id) { return; }

    if (this.isMultiple()) {
      this.onMultipleClick.emit(event as MouseEvent);
    } else if (this.isImage) {
      if (this.document?.defaultView) {
        const filePath = this.serverLinks.getLink(ServerLinkName.File);
        this.document.defaultView.open(`${filePath}${id}`);
      }
    } else {
      this.documentService.downloadDocumentFile(id)
        .pipe(takeUntil(this.destroy$))
        .subscribe((fileData) => {
          const file = new Blob([fileData], { type: this.fileData()?.type });
          saveAs(file, this.fileName);
        });
    }
  }
}
